import { Link } from 'react-router-dom';
import { getIcon } from '@/lib/iconMap';
import { GALLERIES_PAGE } from '@/constants/testIds';
import { useTilt } from '@/lib/useTilt';

export const GalleryCard = ({ category, className = '' }) => {
  const Icon = getIcon(category.icon_name);
  const tilt = useTilt(6);
  return (
    <Link
      ref={tilt.ref}
      onMouseMove={tilt.onMouseMove}
      onMouseLeave={tilt.onMouseLeave}
      style={{ ...tilt.style, transition: 'transform 220ms ease-out' }}
      to={`/galleries/${category.slug}`}
      className={`group relative block overflow-hidden rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] aspect-[3/4] will-change-transform ${className}`}
      data-testid={GALLERIES_PAGE.card(category.slug)}
    >
      <img
        src={category.cover_image_url}
        alt={category.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover hover-zoom-img"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent transition-opacity duration-300 group-hover:from-black/90" />

      <div className="absolute top-4 right-4 rounded-full bg-black/55 border border-[hsl(var(--lxra-gold))]/40 px-3 py-1 text-[11px] tracking-wide text-[hsl(var(--lxra-gold-hover))] backdrop-blur-md shadow-sm">
        {category.session_count}+ sessions
      </div>

      <div className="absolute inset-x-0 bottom-0 p-5 flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[hsl(var(--lxra-gold))]/40 text-[hsl(var(--lxra-gold))] flex-shrink-0">
          <Icon className="h-4 w-4" />
        </span>
        <span className="font-display text-2xl tracking-[0.06em] text-[hsl(var(--lxra-fg))] transition-colors duration-300 group-hover:text-[hsl(var(--lxra-gold))]">
          {category.name.toUpperCase()}
        </span>
      </div>
    </Link>
  );
};
